const formatters = {
    Number: (num: number): string => num.toString(),
    Date: (date: Date): string => date.toISOString(),
    File: (file: File): File => file,
    Blob: (blob: Blob): Blob => blob,
    String: (str: string): string => str,
};

type Formatter = keyof typeof formatters;
type AllowedTypes = number | Date | File | Blob | string;

function appendToFormData(formData: FormData, key: string, value: AllowedTypes): void {
    const type = value?.constructor.name;
    const formatter = formatters[type as Formatter];
    if (formatter) {
        formData.append(key, formatter(value as never));
    }
}

export function formatObjectToFormData<T extends object>(obj: T): FormData {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                appendToFormData(formData, `${key}[${index}]`, item);
            });
        } else {
            appendToFormData(formData, key, value);
        }
    });

    return formData;
}
